module.exports = __webpack_public_path__ + "static/media/muestrabrightfoam.726107d4.png";